<template>
  <div class="container-fluid mt-4" style="max-width: 800px">
    <b-card title="Create User">
      <form @submit.prevent="saveUser">
        <b-form-group label="Username" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.username"
            id="create-user-email"
          />
        </b-form-group>

        <b-form-group label="Password" label-align-sm="left">
          <b-input-group>
            <b-form-input
              type="text"
              v-model="model.password"
              id="create-user-pwd"
            />
            <b-input-group-append>
              <b-button
                variant="secondary"
                @click.prevent="generatePassword"
                id="generate-password-btn"
              >
                Generate
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <hr />

        <b-form-group label="First Name" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.first_name"
            id="create-user-first-name"
          />
        </b-form-group>

        <b-form-group label="Last Name" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.last_name"
            id="create-user-last-name"
          />
        </b-form-group>

        <b-form-group label="Phone Number" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.phone_number"
            id="create-user-phone"
          />
        </b-form-group>

        <hr />

        <b-form-group label="Role" label-align-sm="left">
          <b-form-select
            v-model="model.role"
            :options="roleOptions"
            id="create-user-role"
          />
        </b-form-group>

        <b-form-group label="Tags" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.tags"
            id="create-user-tags"
          />
        </b-form-group>

        <b-form-group v-if="model.role === 'booking-customer'" label="Primary Contact Organization" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.primary_contact_organization"
            id="create-user-primary-contact-org"
            placeholder="Must match TBN booking PrimaryContactOrganization (comma-separated for multiple)"
          />
        </b-form-group>

        <b-form-group v-if="model.role === 'booking-customer'" label="Home Page" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.home_page"
            id="create-user-home-page"
            placeholder="/booking-customer"
          />
        </b-form-group>

        <b-form-group label="Job Title" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.job_title"
            id="create-user-job-title"
          />
        </b-form-group>

        <b-form-group label="Company/Location" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.company_location"
            id="create-user-company-location"
          />
        </b-form-group>
        <span v-if="this.user.tenant == 'dattco-413f464d'">
        <b-form-group label="Employment Status" label-align-sm="left">
          <b-form-select
            v-model="model.employment_status"
            :options="employmentStatusOptions"
            id="create-user-employment_status"
          />
        </b-form-group>
        <b-form-group label="TBN Driver ID" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.tbn_driver_id"
            id="create-user-tbn_driver_id"
          />
        </b-form-group>
        </span>
        <div>
          <b-btn type="submit" variant="success" id="create-user-submit">
            Save
          </b-btn>
          &nbsp;&nbsp;
          <b-btn :to="{ name: 'user_list' }">Cancel</b-btn>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>
import { create_user } from '../networking/apis'
import { mapState } from 'vuex'

export default {
  name: 'user_create',
  data() {
    return {
      model: {
        role: 'customer',
        password: '',
        home_page: '',
        primary_contact_organization: ''
      },
      roleOptions: [
        { value: 'customer-admin', text: 'Fleet Admin' },
        { value: 'customer', text: 'Staff' },
        { value: 'booking-customer', text: 'Booking Customer' },
        { value: 'driver', text: 'Driver' },
        { value: 'customer-care', text: 'Customer Care' },
        { value: 'manager', text: 'Manager' },
        { value: 'dispatch', text: 'Dispatch' },
        { value: 'garage', text: 'Garage' },
        { value: 'wash-bay', text: 'Wash Bay' },
        { value: 'other', text: 'Other' }
      ],
      accounts: [],
      employmentStatusOptions: [
        {value: 'full', text: 'Full Time'},
        {value: 'part', text: 'Part Time'},
        {value: 'casual', text: 'Casual'}
      ]
    }
  },
  methods: {
    generatePassword() {
      const length = 12
      const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*'
      let pwd = ''
      for (let i = 0; i < length; i++) {
        pwd += charset.charAt(Math.floor(Math.random() * charset.length))
      }
      this.model.password = pwd
    },
    async saveUser() {
      try {
        this.$emit('showAlert', 'waiting for response...', 'info')
        const { message, status_code } = await create_user(
          this.user.tenant,
          this.model
        )
        this.$emit('showAlert', message || 'Success!', 'success', 1500)
        this.$router.push({ name: 'user_list' })
      } catch (e) {
        this.$emit(
          'showAlert',
          'error creating user, contact support if needed',
          'danger',
          5000
        )
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user
    })
  },
  watch: {
    'model.role'(newRole) {
      if (newRole === 'booking-customer' && !this.model.home_page) {
        this.model.home_page = '/booking-customer'
      }
      if (newRole !== 'booking-customer') {
        this.model.primary_contact_organization = null
      }
    },
  }
}
</script>

<style>
a { color: white }
</style>
